@use '../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../styles/Constants.scss' as Constants;

$var-checkbox-size: 16px;

.select-checkbox {
	position: relative;
	margin-right: Constants.$val-spacing-xs;

	input[type='checkbox'] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		
		width: $var-checkbox-size;
		height: $var-checkbox-size;
		border: 2px solid Colors.$col-greyMid;
		background-color: transparent;
		border-radius: 2px;
		cursor: pointer;

		&:focus:not(:checked)
		{
			border-color: Colors.$col-greyMid !important;
			background-color: transparent;
		}

		&:checked {
			background-color: Colors.$col-orange;
			border-color: Colors.$col-orange;
			
			&::after {
				content: '';
				position: absolute;
				left: 5px;
				top: 0px;
				width: 6px;
				height: 12px;

				border-right: 2px solid #fff;
				border-bottom: 2px solid #fff;
				transform: rotate(45deg);
			}
		}
	}
}

.checkbox-container {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xxs;
	align-items: center;
}

.jobOption {
	display: flex;
	flex-direction: column;
}

.jobOptionLabel {
	font-weight: bold;
}

.jobOptionSubtitle {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyFontLight;
	display: flex;
	align-items: center;
}

.internalIndicator {
	background: Colors.$col-black;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 14px;
	width: 14px;
	font-size: 8px;
	line-height: 8px;
	color: Colors.$col-white;
	font-weight: bold;
	border-radius: Constants.$val-borderRadius;
	margin-right: Constants.$val-spacing-xs;
}